module.exports = __webpack_public_path__ + "img/Flag_of_the_Democratic_Republic_of_the_Congo.7c302226.svg";